// extracted by mini-css-extract-plugin
module.exports = {"container":"PayPalExpress_container__fHcWj"};